import React from "react";
// import { useNavigate } from "react-router-dom";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
// import CommitteeManagementTable from "./CommitteeManagementTable";
import AddCommitteeMemberModal from "./AddCommitteeMemberModal";

// For Modal
import Dialog from "@mui/material/Dialog";
// import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import CommitteeManagementNew from "./CommitteeManagementNew";


// End

function CommitteeManagement() {
  // For Modal
  const [open, setOpen] = React.useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [showLoader] = React.useState(false);

  const handleClickOpen = (scrollType) => () => {
    setOpen(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    setOpen(false);
  };
 
  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }

  }, [open]);
  // End

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Committee Management</h1>
            <Button
              className="contentTopLefBt primaryBtn"
              //   onClick={() => navigate("/AddResident")}
              onClick={handleClickOpen("body")}
            >
              Add Committee Member
            </Button>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              {/* <CommitteeManagementTable /> */}
              {/* <DemoTable /> */}
              <CommitteeManagementNew />
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="modalMain">
        <Dialog
          open={open}
          // onClose={handleClose}
          scroll={scroll}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
        >
          <DialogTitle id="scroll-dialog-title" className="modalHeading">
            <span>Add Committee Member</span>
            <CloseIcon className="modalCloseBt" onClick={handleClose} />
          </DialogTitle>
          <DialogContent dividers={scroll === "paper"}>
            <div className="modalInnerCont">
              <AddCommitteeMemberModal />
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default CommitteeManagement;
